export const odluka_zast_dost = {
    templateId: 230,
    category: 3,
    templateTitle: 'Odluka o imenovanju osobe ovlaštene za primanje i rješavanje pritužbi vezanih za zaštitu dostojanstva radnika',
    templateDescription: `<p>Poslodavac koji zapošljava najmanje dvadeset radnika dužan je imenovati osobu koja je osim poslodavca ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA DOKUMENTA</strong></h5>
    <p>Poslodavca koji zapošljava najmanje dvadeset radnika, Zakon o radu obvezuje da imenuje osobu koja je osim poslodavca ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika koje se odnosi na uznemiravanje ili spolnog uznemiravanje.</p>
    <p>Uznemiravanje je svako neželjeno ponašanje uzrokovano nekim od sljedećih osnova: rase ili etničke pripadnosti ili boje kože, spola, jezika, vjere, političkog ili drugog uvjerenja, nacionalnog ili socijalnog podrijetla, imovnog stanja, članstva u sindikatu, obrazovanja, društvenog položaja, bračnog ili obiteljskog statusa, dobi, zdravstvenog stanja, invaliditeta, genetskog naslijeđa, rodnog identiteta, izražavanja ili spolne orijentacije, koje ima za cilj ili stvarno predstavlja povredu dostojanstva osobe, a koje uzrokuje strah, neprijateljsko, ponižavajuće ili uvredljivo okruženje.</p>
    <p>Spolno uznemiravanje je svako verbalno, neverbalno ili fizičko neželjeno ponašanje spolne naravi koje ima za cilj ili stvarno predstavlja povredu dostojanstva osobe, koje uzrokuje strah, neprijateljsko, ponižavajuće ili uvredljivo okruženje.</p>
    <p>Poslodavac ili imenovana osoba, dužna je, u roku utvrđenom kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca ili pravilnikom o radu, a najkasnije u roku od osam dana od dostave pritužbe, ispitati pritužbu radnika i poduzeti sve potrebne mjere primjerene pojedinom slučaju radi sprječavanja nastavka uznemiravanja ili spolnog uznemiravanja, ako utvrdi da ono postoji.</p>
    <p>Ako poslodavac u navedenom roku ne poduzme mjere za sprječavanje uznemiravanja ili spolnog uznemiravanja ili ako su mjere koje je poduzeo očito neprimjerene, radnik koji je uznemiravan ili spolno uznemiravan ima pravo prekinuti rad dok mu se ne osigura zaštita, pod uvjetom da je u daljnjem roku od osam dana zatražio zaštitu pred nadležnim sudom.</p>
    <p>Ako postoje okolnosti zbog kojih nije opravdano očekivati da će poslodavac zaštititi dostojanstvo radnika, radnik nije dužan dostaviti pritužbu poslodavcu i ima pravo prekinuti rad, pod uvjetom da je zatražio zaštitu pred nadležnim sudom i o tome obavijestio poslodavca u roku od osam dana od dana prekida rada.</p>
    <p>Svi podaci utvrđeni u postupku zaštite dostojanstva radnika su tajni.</p>
    <p>Ponašanje radnika koje predstavlja uznemiravanje ili spolno uznemiravanje predstavlja povredu obveze iz radnog odnosa.</p>
    <p><strong>Osim obveze imenovanja koja se pobliže određuje odlukom u nastavku, Poslodavac koji zapošljava najmanje dvadeset radnika dužan je donijeti i objaviti pravilnik o radu, a obvezni sadržaj pravilnika o radu je i određivanje postupka i mjera za zaštitu dostojanstva radnika. Primjer pravilnika o radu koji sadržava navedene odredbe možete pogledati <a class="local-link" href="/contract?template=222">ovdje.</a> Razumijeva se da će u tom smislu, imenovana osoba iz ove odluke postupati i donositi odluke sukladno odredbama pravilnika u radu koji regulira postupak i mjere za zaštitu dostojanstva.</strong><p>
    
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neimenovanje osobe (u slučaju da poslodavac zapošljava najmanje dvadeset radnika) koja je osim poslodavca ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika - prekršaj</strong></p>
    <p>Pojašnjenje: ukoliko poslodavac zapošljava dvadeset i više radnika, a ne imenuje osobu koja je osim poslodavca ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika, inspektor će usmenim rješenjem u zapisniku poslodavcu narediti imenovanje takve osobe.</p>
  
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
  sides: [
    {
      prefix: 'Na temelju Zakona o radu,',
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'donosi sljedeću',
  title: 'ODLUKU O IMENOVANJU OSOBE OVLAŠTENE ZA PRIMANJE I RJEŠAVANJE PRITUŽBI VEZANIH ZA ZAŠTITU DOSTOJANSTVA RADNIKA',

  noArticleNumbers: true,

  articles: [

    {
        title: '',
        mandatory: true,
        statements: [
          {
            type: 'input',
            mandatory: true,
            editable: false,
            parts: [
                { type: 'text', content: 'Radnik' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'zaposlen na radnom mjestu' },
                { type: 'input', value: '', required: true, placeholder: "Naziv radnog mjesta"},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                { type: 'text', content: 'imenuje se za osobu koja je, osim Poslodavca, ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika.' },
            ]
          }]
      },
      {
        title: '',
        mandatory: false,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Poslodavac ili imenovana osoba iz ove Odluke dužna je, što je moguće prije, a najkasnije u roku od 8 dana od dostave pritužbe radnika, ispitati pritužbu te ukoliko utvrdi da postoji uznemirivanje ili spolno uznemirivanje, poduzeti sve potrebne mjere primjerene pojedinom slučaju radi sprječavanja nastavka uznemiravanja ili spolnog uznemiravanja. \r\nU postupanju, Poslodavac ili imenovana osoba dužni su se u cijelosti pridržavati odredbi Zakona o radu odnosno drugih internih akata Poslodavca koji reguliraju postupak i mjere za zaštitu dostojanstva radnika. \r\nOvlaštena osoba u vezi s pritužbom može saslušavati podnositelja pritužbe, svjedoke, osobu za koju se tvrdi da je podnositelja pritužbe uznemiravala ili spolno uznemiravala, obaviti suočenje, obaviti očevid te prikupljati druge dokaze kojima se može dokazati osnovanost pritužbe.\r\nO svim radnjama koje poduzme u cilju utvrđivanja činjeničnog stanja ovlaštena osoba će sastaviti zapisnik ili službenu bilješku.'
          }]
      },
      {
        title: '',
        mandatory: false,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Nakon provedenog postupka ovlaštena će osoba u pisanom obliku izraditi odluku kojom može odrediti sljedeće: \r\n- utvrditi da ne postoji uznemiravanje ili spolno uznemiravanje podnositelja pritužbe te odbiti pritužbu podnositelja, ili \r\n- utvrditi da postoji uznemiravanje ili spolno uznemiravanje podnositelja pritužbe te će u kojem slučaju predložiti nadležnom tijelu Poslodavca da osobi koja je podnositelja pritužbe uznemiravala ili spolno uznemiravala izrekne mjeru zbog povrede radne obveze (pisano upozorenje na obveze iz radnog odnosa, redoviti ili izvanredni otkaz ugovora o radu) te predložiti poduzimanje drugih mjera koje su primjerene pojedinom slučaju radi sprječavanja nastavka uznemiravanja.'
          }]
      },
    
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: `Sukladno odredbama Zakona o radu, Poslodavac je dužan imenovati osobu koja je osim njega ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika.`,
        }]
    },
    {
        title: '',
        mandatory: true,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: `Kako imenovani radnik uživa povjerenje radnika, a u skladu s naprijed navedenim, odlučeno je kao u izreci ove Odluke.`,
          }]
      },
      {
        title: '',
        mandatory: false,
        dummy: true,
        statements: [
          {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Ova Odluka stupa na snagu danom donošenja.'
          }]
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska evidencija \r\n\r\nObavijest o odluci: Oglasna ploča',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/230_odluka_zast_dost.ts